import { render } from "./AdsAccOAuthReturn.vue?vue&type=template&id=0915f0cc"
import script from "./AdsAccOAuthReturn.vue?vue&type=script&lang=js"
export * from "./AdsAccOAuthReturn.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__